module.exports = __webpack_public_path__ + "img/search-pink.4f587f47.svg";